var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-location",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.364,
    height: 16,
    viewBox: "0 0 13.364 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pin",
    d: "M6.018,5.018a5.182,5.182,0,0,1,8.846,3.664c0,2.005-1.307,3.965-2.76,5.5a19.311,19.311,0,0,1-1.962,1.793c-.175.139-.33.258-.46.355-.13-.1-.285-.215-.46-.355A19.3,19.3,0,0,1,7.26,14.18c-1.453-1.534-2.76-3.493-2.76-5.5A5.182,5.182,0,0,1,6.018,5.018ZM9.265,17.874l.416-.624.416.624A.751.751,0,0,1,9.265,17.874Zm0,0,.416-.624c.416.624.417.624.417.623h0l0,0,.015-.01.055-.038c.047-.033.115-.08.2-.142.171-.123.412-.3.7-.532a20.8,20.8,0,0,0,2.116-1.935c1.513-1.6,3.171-3.922,3.171-6.53A6.682,6.682,0,1,0,3,8.682c0,2.608,1.659,4.933,3.171,6.53a20.8,20.8,0,0,0,2.116,1.935c.288.23.529.409.7.532.085.062.153.109.2.142l.055.038.015.01,0,0ZM8.455,8.682A1.227,1.227,0,1,1,9.682,9.909,1.227,1.227,0,0,1,8.455,8.682ZM9.682,5.955a2.727,2.727,0,1,0,2.727,2.727A2.727,2.727,0,0,0,9.682,5.955Z",
    transform: "translate(-3 -2)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationWhite);
export default __webpack_public_path__ + "static/media/location-white.f4f75d3c63f20986c6fbaa379eb67d15.svg";
export { ForwardRef as ReactComponent };